module.exports = __webpack_public_path__ + "img/logo-success2.21230ccd.jpg";